/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import AppMap from './AppMap';

export const getAreaName = (location) => {
	try {
		if (!location) return "";
		if (location?.address_component) {
			const components = location.address_component || [];
			let sublocality_level_1 = components.find((e) =>
				e.types.includes("sublocality_level_1"),
			);
			if (sublocality_level_1)
				return sublocality_level_1?.long_name || sublocality_level_1?.short_name;
			let sublocality = components.find((e) =>
				e.types.includes("sublocality"),
			);
			if (sublocality)
				return sublocality?.long_name || sublocality?.short_name;
			let neighborhood = components.find((e) =>
				e.types.includes("neighborhood"),
			);
			if (neighborhood)
				return neighborhood?.long_name || neighborhood?.short_name;
			let locality = components.find((e) => e.types.includes("locality"));
			if (locality) return locality?.long_name || locality?.short_name;
			let administrative_area_level_2 = components.find((e) =>
				e.types.includes("administrative_area_level_2"),
			);
			if (administrative_area_level_2)
				return (
					administrative_area_level_2?.long_name ||
					administrative_area_level_2?.short_name
				);
		}
		let d = location?.address?.split(",");
		return (d?.length >= 2 ? d[1] : d[0]).replace(/[0-9]/g, "").trim();
	} catch (error) {
		if (typeof location === "string") return location;
	}
};

export const FixedLocationSetting = ({ callback }) => {
	return (
			<div className="page-content-wrapper">
				{/* Content */}
				<div className="dashboard-map-wrapper">
					<div className="dashboard-map-wrapper-inner is-reversed">
						<AppMap
							showFeatures={false} 
							order={true} 
							configure={true} 
							hideCircularMenu={true}
                            callback={callback}
						/>
					</div>
				</div>
			</div>
	);
};

export const FixedPointPicker = (props) => {
	const { readOnly = false } = props;

    const [location, setLocation] = React.useState()

    const fixedLocation = location || props?.addressLocation;

	return (
		<div className="card h-card mb-5">
			<div className="card-content">
				<h3 style={{ fontWeight: "bold", marginBottom: 15 }}>
					{props?.riderInitialLocation ? "Set Rider's Location" : "Set Fixed Location"}
				</h3>
				<div className="media-flex-center no-margin">
				
					{fixedLocation && (
                        <div className="message is-primary w-100">
                        <div class="message-body media-flex-center">
                        <div class="h-icon is-medium is-primary">
						<i class="fas fa-map-marker-alt"></i>
					</div>
					<div className="flex-meta" style={{ textTransform: "capitalize" }}>
						<span>{getAreaName(fixedLocation)}</span>
						<span>{fixedLocation?.address}</span>
					</div>
					</div>
					</div>
					)||<div className="flex-meta m-0">
                        <div className="message is-danger w-100">
								<div class="message-body">
                                    Please click <b>Change Location</b> to set your address location.
								</div>
							</div>
						</div>}
				</div>
				
				{!readOnly && (
					<div
						className="right"
						style={{
							position: "absolute",
							right: 25,
							top: 20,
						}}
					>
						<a
							className="action-link"
							onClick={(e) => {
								props.openPanel({
									title: "Address Location",
									customStyle: { width:  405 },
									content: FixedLocationSetting({ 
										callback:(e) => {
                                            props?.setLocationCallBack({
                                                location_address: e?.address,
                                                location_lat: e?.latLng?.lat,
                                                location_lng: e?.latLng?.lng,
                                                location_address_component: JSON.stringify(e?.address_component),
                                            });
                                            setLocation(e)
                                        }
									}),
								});
							}}
							style={{ float: "right" }}
						>
							Change Location
						</a>
					</div>
				)}
			</div>
		</div>
	);
};
